import "../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { treeInjectionKey as a } from "./interface.js";
import s from "../../_internal/icon-switch-transition/src/IconSwitchTransition.js";
import u from "../../_internal/loading/src/Loading.js";
import h from "../../_internal/icon/src/Icon.js";
import m from "../../_internal/icons/Switcher.js";
import { defineComponent as f, inject as p, h as t } from "../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
const I = f({
  name: "NTreeSwitcher",
  props: {
    clsPrefix: {
      type: String,
      required: !0
    },
    indent: {
      type: Number,
      required: !0
    },
    expanded: Boolean,
    selected: Boolean,
    hide: Boolean,
    loading: Boolean,
    onClick: Function,
    tmNode: {
      type: Object,
      required: !0
    }
  },
  setup(r) {
    const {
      renderSwitcherIconRef: i
    } = p(a, null);
    return () => {
      const {
        clsPrefix: e,
        expanded: o,
        hide: d,
        indent: c,
        onClick: l
      } = r;
      return t("span", {
        "data-switcher": !0,
        class: [`${e}-tree-node-switcher`, o && `${e}-tree-node-switcher--expanded`, d && `${e}-tree-node-switcher--hide`],
        style: {
          width: `${c}px`
        },
        onClick: l
      }, t("div", {
        class: `${e}-tree-node-switcher__icon`
      }, t(s, null, {
        default: () => {
          if (r.loading)
            return t(u, {
              clsPrefix: e,
              key: "loading",
              radius: 85,
              strokeWidth: 20
            });
          const {
            value: n
          } = i;
          return n ? n({
            expanded: r.expanded,
            selected: r.selected,
            option: r.tmNode.rawNode
          }) : t(h, {
            clsPrefix: e,
            key: "switcher"
          }, {
            default: () => t(m, null)
          });
        }
      })));
    };
  }
});
export {
  I as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/tree/src/TreeNodeSwitcher.js
// module id = 1717
// module chunks = 41